/**
 * cubicBezier is a function that returns a cubic bezier curve function.
 */
export const cubicBezier = (p0: number, p1: number, p2: number, p3: number) => {
  return (t: number) => {
    const u = 1 - t;
    return 3 * u * u * t * p1 + 3 * u * t * t * p2 + t * t * t;
  };
};
